export default "__VITE_ASSET__CqrmFtzo__"